import * as React from 'react';
import { SVGProps } from 'react';

const IconBookmarkStrokedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 2.5C3 1.67 3.674 1 4.501 1H11.5c.826 0 1.5.67 1.5 1.5V15l-5-2.5L3 15V2.5zM5 3v8.782l3-1.518 3 1.518V3H5z"
    />
  </svg>
);
export default IconBookmarkStrokedSizeS;
